import localeConfig from '../config/locale.config';

let runtimeLocale = localeConfig.intlLocale || 'en-NZ';
let runtimeTimezone = localeConfig.timezone || 'Pacific/Auckland';
let runtimeCurrency = localeConfig.currency?.code || 'NZD';

export function setLocaleDefaults({ locale, timezone, currency } = {}) {
    if (locale) runtimeLocale = String(locale);
    if (timezone) runtimeTimezone = String(timezone);
    if (currency) runtimeCurrency = String(currency).toUpperCase();
}

export function getAppTimezone() {
    return runtimeTimezone;
}

function isTimezoneAware(value) {
    if (value instanceof Date) return true;
    return /([zZ]|[+-]\d{2}:?\d{2})$/.test(String(value || '').trim());
}

export const formatDate = (date) => {
    if (!date) return 'N/A';
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    if (isTimezoneAware(date)) options.timeZone = runtimeTimezone;
    return new Date(date).toLocaleDateString(runtimeLocale, options);
};

export const formatDateTime = (date) => {
    if (!date) return 'N/A';
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };
    if (isTimezoneAware(date)) options.timeZone = runtimeTimezone;
    return new Date(date).toLocaleString(runtimeLocale, options);
};

export const formatNumber = (num) => {
    return new Intl.NumberFormat(runtimeLocale).format(num);
};

export const formatMoney = (amount, currency = runtimeCurrency) => {
    if (amount == null || amount === '' || Number.isNaN(Number(amount))) {
        return '—';
    }
    const code = (currency || runtimeCurrency || 'NZD').toUpperCase();
    try {
        return new Intl.NumberFormat(runtimeLocale, {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(amount));
    } catch {
        return `${code} ${Number(amount).toFixed(2)}`;
    }
};

export const formatPercentage = (value, total) => {
    if (total === 0) return 0;
    return Math.round((value / total) * 100);
};

export const getStatusColor = (status) => {
    const statusColors = {
        pending: 'yellow',
        active: 'blue',
        completed: 'green',
        rejected: 'red',
        expired: 'gray',
    };
    return statusColors[status] || 'gray';
};

export const debounce = (func, wait) => {
    let timeout;
    const executedFunction = function(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    
    // Add cancel method to clear the timeout
    executedFunction.cancel = () => {
        clearTimeout(timeout);
    };
    
    return executedFunction;
};
